import { render, staticRenderFns } from "./ClassVideo.vue?vue&type=template&id=db541590&scoped=true"
import script from "./ClassVideo.vue?vue&type=script&lang=js"
export * from "./ClassVideo.vue?vue&type=script&lang=js"
import style0 from "./ClassVideo.vue?vue&type=style&index=0&id=db541590&prod&scoped=true&lang=css"
import style1 from "./ClassVideo.vue?vue&type=style&index=1&id=db541590&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db541590",
  null
  
)

export default component.exports